<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-12">
            <h1>
              DNS Binding
              <router-link
                :to="{ name: 'DNSBindingAdd' }"
                class="btn ml-auto"
                v-if="actionCreate"
              >
                <i class="icon-plus"></i> New
              </router-link>
            </h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">DNS Binding</li>
            </ol>
          </div>
        </div>
      </div>
      <!-- /.container-fluid -->
    </section>

    <section class="content" v-if="has_permission === true">
      <div class="container-fluid">
        <div class="card">
          <div
            class="card-header py-3"
            v-if="!_.isEmpty(list.data) && is_loading == false"
          >
            <div class="btn-toolbar pull-right">
              <el-dropdown
                split-button
                :trigger="'click'"
                @command="handleSelectedRows"
                type="primary"
                v-if="this.selected_row.length"
                class="mr-1"
              >
                {{ this.selected_row.length }}
                {{ "" | pluralize(this.selected_row.length) }} selected
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="delete">Delete</el-dropdown-item>
                  <el-dropdown-item command="enable">Enable</el-dropdown-item>
                  <el-dropdown-item command="disable">Disable</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <button
                class="btn btn-info"
                type="button"
                @click="showFilter = !showFilter"
              >
                <i class="fa fa-filter"></i>
                <span class="d-none d-sm-inline-flex">Filter</span>
              </button>
            </div>

            <div class="card-tools">
              <button class="btn btn-outline" @click="exportFile()">
                <i class="icon-download"></i>
                <span class="d-none d-sm-inline-flex">Export</span>
              </button>
            </div>
          </div>
          <div class="overlay" v-if="is_loading">
            <img src="/assets/images/loader.svg" alt="" />
          </div>
          <form @submit.prevent="getFilterData()" method="GET" novalidate>
            <div class="card-body" v-if="showFilter">
              <div class="form-row">
                <div class="col-md-6">
                  <!-- Audra Name -->
                  <div v-if="organizationId == 1" class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="audraname">Audra</label>
                    <div class="col-md-9">
                      <div class="input-group">
                        <multiselect
                          v-model="filter.accountId"
                          :options="Object.keys(pre.audraName)"
                          :custom-label="(opt) => pre.audraName[opt]"
                          placeholder="Select Audra"
                          :searchable="true"
                          :multiple="false"
                          id="accountId"
                          v-bind:class="{
                            'has-error': errors.has('accountId'),
                          }"
                          name="accountId"
                        >
                        </multiselect>
                      </div>
                    </div>
                  </div>

                  <!-- IP -->
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="domain_ip">IP</label>
                    <div class="col-md-9">
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text">
                            <i class="fas fa-pencil-alt"></i>
                          </span>
                        </div>
                        <input
                          autocomplete="off"
                          type="text"
                          id="domain_ip"
                          name="domain_ip"
                          v-model="filter.domain_ip"
                          :class="{
                            'has-error': errors.has('name'),
                          }"
                          class="form-control"
                          placeholder="IP"
                        />
                      </div>
                    </div>
                  </div>

                  <!-- Domain -->
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="domain_name"
                      >Domain</label
                    >
                    <div class="col-md-9">
                      <div class="input-group mb-3">
                        <div class="input-group-prepend">
                          <span class="input-group-text">
                            <i class="fas fa-pencil-alt"></i>
                          </span>
                        </div>
                        <input
                          autocomplete="off"
                          type="text"
                          id="domain_name"
                          name="domain_name"
                          v-model="filter.domain_name"
                          :class="{
                            'has-error': errors.has('name'),
                          }"
                          class="form-control"
                          placeholder="Domain"
                        />
                      </div>
                      <button type="submit" class="btn btn-common mr-3">
                        <i class="icon-search"></i> Search
                      </button>
                      <button type="reset" class="btn btn-outline" @click="resetFilter()">
                        <i class="icon-refresh"></i> Reset
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>

          <div class="card-body">
            <div v-if="!_.isEmpty(list.data) && is_loading == false">
              <h6 v-if="organizationId == 1">Total Item: {{ list.total }}</h6>
              <div class="table-responsive-md">
                <table class="table">
                  <thead>
                    <tr>
                      <th style="width: 24px">
                        <label class="checkbox">
                          <input
                            type="checkbox"
                            v-model="is_selected_all"
                            @click="selectedRowAll()" />
                          <span class="checkmark"></span
                        ></label>
                      </th>
                      <th v-if="organizationId == 1">Audra</th>
                      <th>Status</th>
                      <th>IP</th>
                      <th>Domain</th>
                      <th class="text-right">Action</th>
                    </tr>
                  </thead>
                  <tbody class="list">
                    <tr v-for="(val, index) in list.data">
                      <td>
                        <label class="checkbox">
                          <input
                            type="checkbox"
                            v-model="selected_row"
                            :value="{ id: val.id, accountId: val.accountId }" />
                          <span class="checkmark"></span
                        ></label>
                      </td>

                      <td v-if="organizationId == 1">
                        {{ val.device_name }}
                      </td>
                      <td>{{ val.dns_status }}</td>
                      <td>{{ val.domain_ip }}</td>
                      <td>{{ val.domain_name }}</td>
                      <td class="text-right">
                        <router-link
                          v-if="actionEdit == true || checkEditPermission(val)"
                          :to="{
                            name: 'DNSBindingEdit',
                            params: { id: val.id },
                          }"
                          class="btn btn-edit"
                        >
                          <i class="icon-edit"></i>
                        </router-link>
                        <a
                          v-if="actionDelete == true || checkDeletePermission(val)"
                          class="btn btn-trash"
                          href="javascript:void(0)"
                          @click="deleteObject(val.id, val.accountId, index)"
                          ><i class="icon-trash"></i
                        ></a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="mt-2 text-right d-block d-sm-none">
                Swipe <i class="icon-swipe"></i>
              </div>
            </div>
            <div class="p-4" v-if="_.isEmpty(list.data) && is_loading == false">
              <div class="no-data">
                <img src="/assets/images/no-data.svg" alt="" />
                <h3>No data found!</h3>
              </div>
            </div>
          </div>

          <div :class="{ 'card-footer': list.total > list.per_page }">
            <vue-pagination
              :pagination="list"
              v-if="list.total > list.per_page"
              @paginate="reload()"
            ></vue-pagination>
          </div>
        </div>
      </div>
    </section>

    <section class="content" v-if="has_permission === false">
      <div class="alert alert-danger alert-dismissible">
        <h5><i class="icon fas fa-ban"></i> Permission denied!</h5>
      </div>
    </section>
  </div>
</template>

<script>
import VuePagination from "@/components/partials/PaginationComponent";
import SortIcons from "@/components/utils/SortIcons";
import { CommonAPI, PermissionChecker } from "@/services/api";
import LocalStorage from "@/services/localStorage";
import axios from "axios";
import { Notification } from "element-ui";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { mapGetters } from "vuex";
// const fileDownload = require("js-file-download");
import { fileDownload } from "@/utils/CommonUtils";

export default {
  name: "DNSBinding",
  metaInfo: {
    title: "DNS Binding | Dotlines",
  },
  components: {
    DatePicker,
    VuePagination,
    SortIcons,
  },
  data: () => ({
    organizationId: LocalStorage.get("organizationId"),
    userEmail: LocalStorage.get("userEmail"),
    list: {
      total: 0,
      per_page: 1,
      from: 1,
      to: 0,
      current_page: 1,
    },
    actionCreate: true,
    actionView: true,
    actionEdit: true,
    actionDelete: true,
    api_url: "",
    showFilter: false,
    filter: {},
    dateRange: "",
    pre: {
      audraName: {},
    },
    is_loading: false,
    empty: false,
    empty_message: "",
    custom_permission_data: [],
    has_permission: true,
    selected_row: [],
    is_selected_all: false,
  }),
  mounted: function () {
    if (this.isMobile()) {
      window.$(document).find(".push-menu-class").trigger("click");
    }
    this.api_url = "/dns_bindings";
    this.initialize();
    this.$root.$on("sort-data", () => {
      this.$root.$emit("show-icon");
      this.reload();
    });
  },
  computed: {
    ...mapGetters(["profile"]),
  },
  methods: {
    async initialize() {
      this.is_loading = true;
      if (_.isEmpty(this.profile)) {
        await CommonAPI.getProfile().then((profile_info) => {
          this.user_detail = profile_info;
        });
      } else {
        this.user_detail = this.profile;
      }

      // await CommonAPI.getCustomPermission(
      //   "/get-custom-permission-infos?path=api/dns_bindings"
      // ).then((response) => {
      //   if (response.status == 200) {
      //     this.custom_permission_data = response.data;
      //   }
      // });

      // if (!_.isEmpty(this.custom_permission_data)) {
      //   this.actionCreate = await PermissionChecker.checkCreateButtonPermission(
      //     this.custom_permission_data.action_permission,
      //     this.custom_permission_data["create_id_condition"],
      //     this.user_detail,
      //     this.custom_permission_data.enableAdministratorPermissionByDefault
      //   );
      //   this.actionCreate = true;
      // }

      await this.getList()
        .then((response) => {
          this.list = response.data;
        })
        .catch((error) => {
          this.empty = true;
          if (error.response.status === 403) {
            this.has_permission = false;
          }
        });

      await CommonAPI.getAudraName(LocalStorage.get("accountId"))
        .then((response) => {
          this.pre.audraName = response;
        })
        .catch((error) => {
          console.log(error.response);
        });

      this.is_loading = false;
    },
    async getFilterData() {
      this.is_loading = true;
      await this.getList()
        .then((response) => {
          this.list = response.data;
        })
        .catch((error) => {
          this.empty = true;
          if (error.response.status === 403) {
            this.has_permission = false;
          }
        });
      this.is_loading = false;
    },
    reload: function () {
      this.getList()
        .then((response) => {
          this.list = response.data;
        })
        .catch((error) => {
          this.empty = true;
          if (error.response.status === 403) {
            this.has_permission = false;
          }
        });
    },
    getList: function () {
      return new Promise((resolve, reject) => {
        let params = { page: this.list.current_page };
        params = {
          ...this.filter,
          userAccountId: LocalStorage.get("accountId"),
          ...this.$route.query,
          ...params,
        };
        axios
          .get(this.api_url, {
            params: params,
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
            // console.log("error", error.response.data);
          })
          .finally(() => {
            // _this.is_loading = false;
          });
      });
    },
    checkEditPermission: function (data) {
      if (!_.isEmpty(this.custom_permission_data)) {
        return PermissionChecker.checkEditButtonPermission(
          this.custom_permission_data.action_permission,
          this.custom_permission_data["edit_id_condition"],
          this.custom_permission_data["edit_refid_condition"],
          this.custom_permission_data["edit_custom_condition"],
          data,
          this.user_detail,
          this.custom_permission_data.enableAdministratorPermissionByDefault
        );
      } else {
        return false;
      }
    },
    checkDeletePermission: function (data) {
      if (!_.isEmpty(this.custom_permission_data)) {
        return PermissionChecker.checkDeleteButtonPermission(
          this.custom_permission_data.action_permission,
          this.custom_permission_data["delete_id_condition"],
          this.custom_permission_data["delete_refid_condition"],
          this.custom_permission_data["delete_custom_condition"],
          data,
          this.user_detail,
          this.custom_permission_data.enableAdministratorPermissionByDefault
        );
      } else {
        return false;
      }
    },
    async resetFilter() {
      this.list.current_page = 1;
      this.filter = {};
      this.is_loading = true;
      await this.getList()
        .then((response) => {
          this.list = response.data;
        })
        .catch((error) => {
          this.empty = true;

          if (error.response.status === 403) {
            this.has_permission = false;
          }
        });
      this.is_loading = false;
    },
    deleteObject: function (id, accountId, index) {
      const _this = this;
      const delete_api_url = "/dns_bindings/" + id;

      _this.$swal
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!",
        })
        .then((result) => {
          if (result.isConfirmed) {
            _this.is_loading = true;
            axios
              .delete(delete_api_url, {
                params: {
                  accountId: accountId,
                },
              })
              .then((response) => {
                _this.list.data.splice(index, 1);
                _this.$toaster.success(response.data.message);
                _this.is_loading = false;
              })
              .catch((error) => {
                _this.is_loading = false;
                console.log(error);
                _this.$swal.fire("Failed!", "failed to delete.", "error");
              })
              .finally(() => {
                _this.is_loading = false;
              });
          }
        });
    },
    exportFile: function () {
      this.is_loading = true;
      axios
        .get("/dns-bindings-export", {
          params: { userAccountId: LocalStorage.get("accountId") },
          responseType: "blob",
        })
        .then((response) => {
          fileDownload(response.data, "dns_bindings.xlsx");
          Notification.success({
            title: "Export Completed",
            message: "Export operation completed successfully",
            type: "success",
          });
        })
        .catch((error) => {
          console.log("error " + error);
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
    selectedRowAll: function () {
      const isSelectedAll = (this.is_selected_all = !this.is_selected_all);
      if (isSelectedAll) {
        var items = [];
        this.list.data.forEach(function (item) {
          items.push({ id: item.id, accountId: item.accountId });
        });
        this.selected_row = items;
      } else {
        this.selected_row = [];
      }
    },
    handleSelectedRows(command) {
      let type = 0;
      let notificationMessage;
      let notificationTitle;

      if (command === "delete") {
        notificationMessage = "Data deleted successfully";
        notificationTitle = "Deleted Successfully";
      } else {
        if (command === "enable") {
          type = 1;
        }
        notificationMessage = "Data Updated successfully";
        notificationTitle = "Updated Successfully";
      }

      axios({
        method: "POST",
        url: "/dns_bindings-bulk-action",
        data: { ids: this.selected_row, type: type, action: command },
        headers: { "Content-Type": "application/json" },
      })
        .then(function (response) {
          Notification.success({
            title: notificationTitle,
            message: notificationMessage,
            type: "success",
          });
          // this.initialize();
        })
        .catch((errors) => {
          if (!_.isEmpty(errors.response)) {
            if (errors.response.status === 501) {
              this.$toaster.error(errors.response.data.errors.message)
            } else {
              this.$toaster.error(errors.response.data.message);
            }
          }
        })
        .finally(() => {
          this.is_selected_all = false;
          this.selected_row = [];
          this.initialize();
        });
    },
  },
};
</script>
